var map = {
	"./arrow.png": "68f9",
	"./arrow.svg": "8ddf",
	"./background.png": "4e9a",
	"./corner-logo.png": "fa58",
	"./cross.png": "ffe9",
	"./cross.svg": "edfb",
	"./doodle-1.png": "d51d",
	"./doodle-2.png": "b479",
	"./green-tick.png": "c707",
	"./intro-header.png": "a27c",
	"./irish-aid-logo.png": "b9a3",
	"./magazine-cover-one.jpg": "6290",
	"./magazine-cover-two.jpg": "b711",
	"./score-background.png": "9539",
	"./timer-background.png": "df95",
	"./yellow-tick.png": "4fcc",
	"./yellow-tick.svg": "d527"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "33db";